import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import i18n from '../../i18n/i18n';
import {
  IEnrollmentPolicyResponse,
  IEnrollmentPolicyResponseById,
  IEnrollmentPolicyState,
} from '../../interface/enrollmentPolicy.interface';
import { fetchEnrollmentPolicy, fetchEnrollmentPolicies } from '../action/enrollmentPolicy.action';

const initialState: IEnrollmentPolicyState = {
  policies: [],
  policy: null,
  pagination: null,
  isLoading: false,
  error: null,
};

const enrollmentPolicySlice = createSlice({
  name: 'enrollmentPolicy',
  initialState,
  reducers: {
    resetEnrollmentPolicy: (state) => {
      state.policy = null;
    },
    resetEnrollmentPolicies: (state) => {
      state.policies = [];
      state.pagination = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch all enrollment policies
      .addCase(fetchEnrollmentPolicies.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.policies = [];
        state.pagination = null;
      })
      .addCase(
        fetchEnrollmentPolicies.fulfilled,
        (state, action: PayloadAction<IEnrollmentPolicyResponse>) => {
          state.isLoading = false;
          state.policies = action.payload.data.policies;
          state.pagination = {
            page: action.payload.data.page,
            pageSize: action.payload.data.pageSize,
            total: action.payload.data.total,
            totalPages: action.payload.data.totalPages,
          };
        },
      )
      .addCase(fetchEnrollmentPolicies.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          i18n.t(
            'toast.failed_to_fetch_enrollment_policies',
            'Failed to fetch enrollment policies.',
          );
        state.policies = [];
        state.pagination = null;
      })
      // Fetch single enrollment policy
      .addCase(fetchEnrollmentPolicy.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.policy = null;
      })
      .addCase(
        fetchEnrollmentPolicy.fulfilled,
        (state, action: PayloadAction<IEnrollmentPolicyResponseById>) => {
          state.isLoading = false;
          state.policy = action.payload.data.policy;
          state.error = null;
        },
      )
      .addCase(fetchEnrollmentPolicy.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          i18n.t('toast.failed_to_fetch_enrollment_policy', 'Failed to fetch enrollment policy.');
        state.policy = null;
      });
  },
});

export const { resetEnrollmentPolicy, resetEnrollmentPolicies } = enrollmentPolicySlice.actions;

export default enrollmentPolicySlice.reducer;
